import { IconDefinition } from "./types";

const square: IconDefinition = {
  iconName: "square",
  width: 448,
  height: 512,
  svgPathData:
    "M400 80l0 352-352 0 0-352 352 0zM48 32l-48 0 0 448 448 0 0-448-400 0z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "square",
  unicode: 0xf0c8,
};

export { square };
